import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addNavigate } from 'shared/src/utils/addNavigate'
import cx from 'classnames'
import { Link } from 'react-router-dom'
import { Trans } from 'react-i18next'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { serifFontFamily } from 'utils/styles'
import { addRodeoOrEditViewContext } from 'utils/rodeoOrEditViewContext'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  italics: {
    fontStyle: 'italic',
  },
  slash: {
    color: '#797979',
    margin: '0 12px',
    fontSize: 20,
    lineHeight: '140%',
    fontWeight: 500,
    letterSpacing: '0.01em',
    fontFamily: 'sans-serif',
  },
  linkText: {
    fontFamily: serifFontFamily,
    color: '#fff',
    fontSize: 20,
    fontWeight: 500,
    letterSpacing: 0.01,
    textDecoration: 'none',
    paddingBottom: 5,
  },
  underline: {
    height: 2,
    width: 14,
    backgroundColor: '#CBA67A',
    alignSelf: 'center',
  },
  unselectedTab: {
    color: '#797979',
    borderBottom: 'none',
  },
})

export const RodeoAndEditTabs: FC = flowMax(
  addDisplayName('RodeoAndEditTabs'),
  addNavigate,
  addProps(() => ({
    classes: useStyles(),
  })),
  addRodeoOrEditViewContext,
  addTranslationHelpers,
  ({ rodeoOrEditView, classes, t }) => (
    <div className={classes.container}>
      <span className={classes.linkContainer}>
        <Link
          to="/"
          className={cx(
            classes.linkText,
            rodeoOrEditView !== 'rodeo' && classes.unselectedTab
          )}
        >
          <Trans t={t} i18nKey="home.rodeo">
            <span className={classes.italics} />
          </Trans>
        </Link>
        {rodeoOrEditView === 'rodeo' && <span className={classes.underline} />}
      </span>
      <span className={classes.slash}>/</span>
      <span className={classes.linkContainer}>
        <Link
          to="/edits"
          className={cx(
            classes.linkText,
            rodeoOrEditView !== 'edit' && classes.unselectedTab
          )}
        >
          {t('home.edits')}
        </Link>
        {rodeoOrEditView === 'edit' && <span className={classes.underline} />}
      </span>
    </div>
  )
)
